var _defs, _circle, _circle2, _g, _circle3, _circle4, _path, _polygon, _polygon2, _polygon3, _polygon4, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountries20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ring",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7f9bd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#26356b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#141d3f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "face",
    cx: 0.35,
    cy: 0.28,
    r: 0.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#354a86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1b2650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#ffffff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 97,
    fill: "url(#ring)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 97,
    fill: "none",
    stroke: "#141d3f",
    strokeWidth: 2.5,
    opacity: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7f9bd6",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186.3,
    cy: 117.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.2,
    cy: 148.9,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.9,
    cy: 173.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.2,
    cy: 186.3,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8,
    cy: 186.3,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 173.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8,
    cy: 148.9,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 117.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 82.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8,
    cy: 51.1,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 26.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8,
    cy: 13.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.2,
    cy: 13.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.9,
    cy: 26.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.2,
    cy: 51.1,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.3,
    cy: 82.8,
    r: 3.1
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 79,
    fill: "url(#face)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 79,
    fill: "none",
    stroke: "#141d3f",
    strokeWidth: 2,
    opacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 21 100 A 79 79 0 0 1 179 100 Z",
    fill: "url(#gloss)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "68.5,35.5 70.7,40.9 76.6,41.4 72.1,45.2 73.5,50.9 68.5,47.8 63.5,50.9 64.9,45.2 60.4,41.4 66.3,40.9",
    fill: "#141d3f",
    stroke: "#7f9bd6",
    strokeWidth: 1.2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.5,35.5 91.7,40.9 97.6,41.4 93.1,45.2 94.5,50.9 89.5,47.8 84.5,50.9 85.9,45.2 81.4,41.4 87.3,40.9",
    fill: "#141d3f",
    stroke: "#7f9bd6",
    strokeWidth: 1.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "110.5,35.5 112.7,40.9 118.6,41.4 114.1,45.2 115.5,50.9 110.5,47.8 105.5,50.9 106.9,45.2 102.4,41.4 108.3,40.9",
    fill: "#141d3f",
    stroke: "#7f9bd6",
    strokeWidth: 1.2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.5,35.5 133.7,40.9 139.6,41.4 135.1,45.2 136.5,50.9 131.5,47.8 126.5,50.9 127.9,45.2 123.4,41.4 129.3,40.9",
    fill: "#141d3f",
    stroke: "#7f9bd6",
    strokeWidth: 1.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 46,
    fill: "#ffffff",
    stroke: "#141d3f",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 19.32,
    ry: 46,
    fill: "none",
    stroke: "#141d3f",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 100,
    x2: 146,
    y2: 100,
    stroke: "#141d3f",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.22 80.68 Q 100 92.64 142.78 80.68",
    fill: "none",
    stroke: "#141d3f",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.22 119.32 Q 100 107.36 142.78 119.32",
    fill: "none",
    stroke: "#141d3f",
    strokeWidth: 1.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,104) scale(0.56)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 31,
    rx: 43,
    ry: 9.5,
    fill: "#c05f00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 29,
    rx: 43,
    ry: 9.5,
    fill: "#e07f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -34 29 L -8.5 -46 Q 0 -52.5 8.5 -46 L 34 29 Z",
    fill: "#ff9911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -50.6 L 8.5 -46 L 34 29 L 0 29 Z",
    fill: "#e07f00",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -21.7 -6 L 21.7 -6 L 26.5 8 L -26.5 8 Z",
    fill: "#f4f4f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -6 L 21.7 -6 L 26.5 8 L 0 8 Z",
    fill: "#d9d9de",
    opacity: 0.55
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 136,
    width: 56,
    height: 38,
    rx: 19,
    fill: "#141d3f",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 138,
    width: 52,
    height: 34,
    rx: 17,
    fill: "none",
    stroke: "#7f9bd6",
    strokeWidth: 1.6,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 165,
    textAnchor: "middle",
    fontFamily: "Arial Black, Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: "bold",
    fill: "#ffffff",
    letterSpacing: 0.5
  }, "20"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountries20);
export default __webpack_public_path__ + "static/media/countries-20.6fe9adffffa73b4c1cbf94ba8112e153.svg";
export { ForwardRef as ReactComponent };